// /app/frontend/src/api/messages.js
import api from "./client";

export async function sendMessage({ match_id, content }) {
  const res = await api.post("/messages", { match_id, content });
  return res.data;
}
